import { Injectable } from '@angular/core';

@Injectable()
export class MapColorService {
  colorRamp: any[] = [
    [254, 0, 0, 1],
    [10, 255, 5, 1],
    [0, 0, 254, 1],
    [146, 96, 38, 1],
    [107, 222, 110, 1],
    [237, 62, 126, 1],
    [11, 69, 18, 1],
    [244, 157, 213, 1],
    [72, 149, 15, 1],
    [121, 34, 180, 1],
    [192, 222, 164, 1],
    [119, 0, 76, 1],
    [75, 214, 253, 1],
    [78, 36, 35, 1],
    [252, 209, 7, 1],
    [51, 58, 158, 1],
    [241, 169, 112, 1],
    [7, 77, 101, 1],
    [218, 207, 241, 1],
    [143, 15, 18, 1],
    [58, 147, 113, 1],
    [224, 89, 21, 1],
    [142, 128, 251, 1],
    [175, 91, 137, 1],
    [41, 140, 192, 1],
    [254, 22, 244, 1],
    [201, 98, 252, 1],
  ];
  birdList: any;

  constructor() {}
}
